import type { AgeGateEnum, BloomMenuTheme } from '@iheartjane/data-access';
import type { Nullish } from '@iheartjane/types';
import { setCookie } from '@iheartjane/utils';

import { durations } from '@jane/bloom/utils/durations';

export const getAgeGateCookieName = (
  theme: BloomMenuTheme,
  type: AgeGateEnum,
  cookiePrefix: Nullish<string>
): string =>
  `${cookiePrefix ?? ''}${theme.bloom?.age_gate?.[type]?.cookie_name || '__jane_bloom_age_gate_default'}`;

export const confirmAge = (
  cookieName: string,
  expirySeconds?: Nullish<number>
) => {
  const expiry = expirySeconds ?? durations.ONE_WEEK;
  return setCookie(cookieName, 'true', expiry > 0 ? expiry : undefined);
};
